import React from 'react';
import { InlineShareButtons } from 'sharethis-reactjs';

const UpdatedModal = (props) => {
    const {
        showPublishedModal,
        shareUrl,
        setCopiedLink,
        copiedLink,
        setShowShareIcons,
        showShareIcons,
    } = props;
    return (
        <div className="UpdatedModal" style={{ display: showPublishedModal ? 'flex' : 'none' }}>
            <h3 className="UpdatedModal-label">
                Published
            </h3>
            <div>You can now close this window</div>
            <div className="UpdatedModal-url">{shareUrl}</div>
            <div className="UpdatedModal-buttons">
                <div className="UpdatedModal-copylink"
                    onClick={() => {
                        navigator.clipboard.writeText(shareUrl);
                        setCopiedLink(true);
                    }}>{copiedLink ? "Link copied" : "Copy link"}</div>
                <div className="UpdatedModal-share"
                    onClick={() => {
                        setShowShareIcons(!showShareIcons);
                    }}>Share</div>
            </div>
            <div className="UpdatedModal-shareIcons">
                {showShareIcons ?
                    <InlineShareButtons
                        config={{
                            alignment: 'center',  // alignment of buttons (left, center, right)
                            color: 'social',      // set the color of buttons (social, white)
                            enabled: true,        // show/hide buttons (true, false)
                            font_size: 16,        // font size for the buttons
                            labels: 'null',        // button labels (cta, counts, null)
                            language: 'en',       // which language to use (see LANGUAGES)
                            networks: [           // which networks to include (see SHARING NETWORKS)
                                'facebook',
                                'twitter',
                                'linkedin',
                                'messenger',
                                'email',
                            ],
                            padding: 12,          // padding within buttons (INTEGER)
                            radius: 4,            // the corner radius on each button (INTEGER)
                            show_total: true,
                            size: 30,             // the size of each button (INTEGER)

                            // OPTIONAL PARAMETERS
                            url: shareUrl,
                            image: window.location.href.replace(router.asPath, props.ifloorplanNowState.splash_screen),  // (defaults to og:image or twitter:image)
                            description: 'This is my new iFloorPlan',       // (defaults to og:description or twitter:description)
                            title: 'Take a look around this property',            // (defaults to og:title or twitter:title)
                            message: shareUrl + '\nClick the icons on the floor plan to see the image taken from that spot. \n',     // (only for email sharing)
                            subject: 'Take a look around this property',  // (only for email sharing)
                        }}
                    /> : ""}
            </div>
        </div>
    )
}

export default UpdatedModal;